import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Link,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import clsx from 'clsx';
import moment from 'moment';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ApprovalStatusColumn from '../../../../components/Admin/Automation/ApprovalStatusColumn';
import DateFilter from '../../../../components/Admin/Automation/List/DateFilter';
import Loader from '../../../../components/Loader';
import Snackbar from '../../../../components/SnakBar';
import MultipleSelectAutoComplete from '../../../../components/common/MultipleSelectAutoComplete';
import OutlinedButton from '../../../../components/common/OutlinedButton';
import { PERMIT_SERVICE_ROLES } from '../../../../utils/constants';
import { getReferenceStatus, getStatus } from '../../../../utils/helper';
import { get, includes, isEmpty, isEqual } from '../../../../utils/lodash';
import { getAllAHJ, getAllAHJCodesByField, getAllApprovedAHJCitiesByCountiesAndState, getAllApprovedAHJCountiesByState, getAllApprovedAHJStates, setAHJFilters, updateAHJRecords } from '../../actions';
import {
  AHJ_FIELDS,
  AHJ_LISTING_COLUMNS,
  AHJ_REFERENCE_STATUS_LIST,
  APPROVAL_STATUS_LIST,
  DATE_FILTER_LIST,
  MULTIPLE_CITITES_COUNTIES_OPTIONS,
  VIEW_ONLY_ROLES,
  YES_NO_OPTIONS,
  statesAbbr,
  statesList,
} from '../../constants';
import { selectMultipleRender } from '../../helper';
import UpdateAHJRecords from '../UpdateRecords';

const styles = (theme) => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    '& .MuiIconButton-root': {
      borderRadius: 0,
    },
    '& .highcharts-credits': {
      display: 'none',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
    color: theme.palette.primary.dark,
  },
  button: {
    color: theme.palette.primary.main,
    fontSize: 10,
  },
  container: {
    maxHeight: '70vh',
    minHeight: '65vh',
  },
  longContainer: {
    maxHeight: '70vh',
    minHeight: '65vh',
  },
  headerButton: {
    color: theme.palette.primary.yellow,
    textTransform: 'none',
    fontSize: '16px',
  },
  tableRow: {
    padding: theme.spacing(1.5),
  },
  tableHeader: {
    backgroundColor: '#335977',
  },
  headerContainer: {
    color: '#FFE785',
    fontSize: 13,
    fontWeight: 'bold',
    position: 'sticky',
    padding: 0,
    border: 'none',
    backgroundColor: '#fff',
  },
  headerText: {
    color: '#FFE785',
    fontSize: 13,
    fontWeight: 'bold',
    backgroundColor: '#335977',
    position: 'sticky',
    display: 'flex',
  },
  searchTableCell: {
    display: 'flex',
    height: theme.spacing(4.25),
    padding: theme.spacing(1.5),
    backgroundColor: '#fff',
  },
  inputField: {
    height: theme.spacing(1.75),
  },
  headerButtonText: {
    height: theme.spacing(4),
    color: theme.palette.primary.yellow,
    textTransform: 'none',
    fontSize: '16px',
    width: 'max-content',
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  styleSelect: {
    height: theme.spacing(4.25),
  },
  headerSideElements: {
    display: 'flex',
  },
  selectContainer: {
    display: 'flex',
    marginRight: theme.spacing(3),
  },
  selectText: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.7),
  },
  filterStyleSelect: {
    height: theme.spacing(4.25),
    width: theme.spacing(17),
  },
  approvalStatus: {
    padding: theme.spacing(0, 2, 0, 0),
  },
  inputCheckbox: {
    color: theme.palette.primary.main,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  inputCheckboxForm: {
    width: theme.spacing(17),
  },
  ahjName: { textAlign: 'left !important' },
  clearFilterButton: {
    fontWeight: 400,
    height: theme.spacing(4.5),
    textTransform: 'uppercase',
    padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
    fontSize: theme.spacing(1.6),
    marginRight: theme.spacing(3),
  },
  updateRecordsButton: {
    fontWeight: 400,
    height: theme.spacing(4.5),
    textTransform: 'uppercase',
    padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
    fontSize: theme.spacing(1.6),
    marginRight: theme.spacing(1),
  },
  displayOptionText: {
    fontSize: theme.spacing(1.9),
    lineHeight: theme.spacing(0.18),
  },
  displayOptionBox: {
    width: theme.spacing(20),
    height: theme.spacing(5, '!important'),
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap',
      overflow: 'hidden',
      paddingRight: theme.spacing(1.125, '!important'),
      height: theme.spacing(4.4),
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 280,
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

const RefStatusMenuProps = {
  ...MenuProps,
  PaperProps: {
    style: {
      ...MenuProps.PaperProps.style,
      width: 450,
    },
  },
};

export class StatusDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 50,
      sort_column: '',
      sort_order: '',
      modifiedDate: '',
      modifiedDateValue: '',
      modifiedDateText: '',
      isFromModifiedDate: false,
      approvedDate: '',
      approvedDateValue: '',
      approvedDateText: '',
      selectedDate: '',
      isFromApprovedDate: false,
      isDateRangeOpen: false,
      enableButton: false,
      dateRange: {},
      showUpdateDialog: false,
      selectSpecificDateOpen: false,
      enableSelectedButton: false,
      filterRecord: 'personal',
      isRecordsToggleSet: false,
      isServiceRoleFetched: false,
      selectedApprovalStatus: ['All'],
      selectedReferenceStatus: ['All'],
      selectedState: [],
      filterValues: {},
      approvedAHJStatesList: [],
      approvedAHJCountiesByStateList: [],
      approvedAHJCitiesByCountiesAndStateList: [],
      ahjCodesList: [],
      updateAHJ: {
        cities: [],
        cityIds: [],
        counties: [],
        countyIds: [],
        state: '',
        field: '',
        fieldId: '',
        update_to: [],
        fieldValue: [],
      },
    };
    this.timeout = null;
    this.filterParams = { ...this.filterParams, filter_record: '' };
    this.setChartData = false;
  }

  handleChangeRowsPerPage(event) {
    if (event.target.value) {
      this.props.getAllAHJ({
        pageNum: 0,
        recordCount: event.target.value,
        sort_column: this.state.sort_column,
        sort_order: this.state.sort_order,
        ...this.filterParams,
      });
      this.setState({ rowsPerPage: event.target.value, page: 0 }, () => {
        this.saveSearchFilters();
      });
    }
  }

  handleChangePage(event, newPage) {
    this.props.getAllAHJ({
      pageNum: newPage,
      recordCount: this.state.rowsPerPage,
      sort_column: this.state.sort_column,
      sort_order: this.state.sort_order,
      ...this.filterParams,
    });
    this.setState({ page: newPage }, () => {
      this.saveSearchFilters();
    });
  }

  sortData(column_id) {
    let sOrder = '';
    if (this.state.sort_column === column_id) {
      if (this.state.sort_order === 'asc') {
        sOrder = 'desc';
      } else {
        sOrder = 'asc';
      }
      this.props.getAllAHJ({
        pageNum: 0,
        recordCount: this.state.rowsPerPage,
        sort_column: this.state.sort_column,
        sort_order: sOrder,
        ...this.filterParams,
      });
      this.setState({ sort_order: sOrder }, () => {
        this.saveSearchFilters();
      });
    } else {
      this.props.getAllAHJ({
        pageNum: 0,
        recordCount: this.state.rowsPerPage,
        sort_column: column_id,
        sort_order: 'asc',
        ...this.filterParams,
      });
      this.setState({ sort_column: column_id, sort_order: 'asc' }, () => {
        this.saveSearchFilters();
      });
    }
  }

  handleFilterDateChange = (event, column) => {
    const isModifiedDate = column.key === 'modified_at';
    let value = get(event, 'target.value', '');
    if (!isEmpty(value)) {
      isModifiedDate ? this.setState({ modifiedDateValue: value }) : this.setState({ approvedDateValue: value });
    } else {
      value = isModifiedDate ? this.state.modifiedDateValue : this.state.approvedDateValue;
    }
    let showDatePicker = false;
    const selectedDateFilter = DATE_FILTER_LIST.find((dateFilter) => dateFilter.key === value);
    if (value === 'date_range') {
      showDatePicker = true;
      this.setState({ isDateRangeOpen: true });
      isModifiedDate ? this.setState({ isFromModifiedDate: true }) : this.setState({ isFromApprovedDate: true });
    } else if (['specific_date', 'all_dates_before', 'all_dates_after'].includes(value)) {
      showDatePicker = true;
      this.setState({ selectSpecificDateOpen: true });
      isModifiedDate ? this.setState({ isFromModifiedDate: true }) : this.setState({ isFromApprovedDate: true });
      if (value === 'all_dates_before') {
        this.setState({ isAllDaysBefore: true });
      } else if (value === 'all_dates_after') {
        this.setState({ isAllDaysAfter: true });
      } else {
        this.setState({ isAllDaysBefore: false, isAllDaysAfter: false });
      }
    }
    if (!showDatePicker) {
      const startSearchKey = column.key === 'modified_at' ? 'from_modified_at' : 'from_verified_at';
      const endSearchKey = column.key === 'modified_at' ? 'to_modified_at' : 'to_verified_at';
      const todayDate = new Date();
      const todayStartingDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
      switch (value) {
        case 'today':
          this.filterParams[startSearchKey] = todayStartingDate.getTime();
          this.filterParams[endSearchKey] = todayStartingDate.getTime() + 86400000;
          break;
        case 'past_7_days':
          const weekEarlierDate = new Date(todayStartingDate.getTime() - 7 * 24 * 60 * 60 * 1000);
          this.filterParams[startSearchKey] = weekEarlierDate.getTime();
          this.filterParams[endSearchKey] = todayStartingDate.getTime() + 86400000;
          break;
        case 'month_date':
          const startMonthDate = new Date(moment().startOf('month'));
          this.filterParams[startSearchKey] = startMonthDate.getTime();
          this.filterParams[endSearchKey] = todayStartingDate.getTime() + 86400000;
          break;
        case 'year_date':
          const startYearDate = new Date(moment().startOf('year'));
          this.filterParams[startSearchKey] = startYearDate.getTime();
          this.filterParams[endSearchKey] = todayStartingDate.getTime() + 86400000;
          break;
        case 'clear_dates':
          value = '';
          this.filterParams[startSearchKey] = '';
          this.filterParams[endSearchKey] = '';
          break;
        default:
          break;
      }
      this.handleFilter();
      const dateText = value === '' ? '' : get(selectedDateFilter, 'text', '');
      isModifiedDate ? this.setState({ modifiedDateText: dateText }) : this.setState({ approvedDateText: dateText });
    }
  };

  handleCloseDateRange = () => {
    this.setState({
      isDateRangeOpen: false,
      enableButton: false,
      isFromModifiedDate: false,
      isFromApprovedDate: false,
    });
  };

  handleDateRangeChange = (range) => {
    this.setState({ dateRange: range });
    !this.state.enableButton && this.setState({ enableButton: true });
  };

  handleDateChange = (date) => {
    this.setState({ selectedDate: date });
    !this.state.enableSelectedButton && this.setState({ enableSelectedButton: true });
  };

  handleSaveDateRange = () => {
    this.setState({ isDateRangeOpen: false, enableButton: false });
    const { startDate, endDate } = this.state.dateRange;
    const modifiedStartDate = moment(startDate).format('M/D/YY');
    const modifiedEndDate = moment(endDate).format('M/D/YY');
    const dateFilterText = `${modifiedStartDate} - ${modifiedEndDate}`;
    let startSearchKey;
    let endSearchkey;
    if (this.state.isFromModifiedDate) {
      startSearchKey = 'from_modified_at';
      endSearchkey = 'to_modified_at';
      this.setState({ modifiedDateText: dateFilterText, isFromModifiedDate: false });
    }
    if (this.state.isFromApprovedDate) {
      startSearchKey = 'from_modified_at';
      endSearchkey = 'to_verified_at';
      this.setState({ approvedDateText: dateFilterText, isFromApprovedDate: false });
    }
    this.filterParams[startSearchKey] = new Date(modifiedStartDate).getTime();
    this.filterParams[endSearchkey] = new Date(modifiedEndDate).getTime() + 86400000;
    this.handleFilter();
  };

  handleUpdateRecords = () => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.props.getAllApprovedAHJStates({
        successCb: () => {
          this.setState({
            showUpdateDialog: true,
          });
        },
      });
    }, 1000);
  };

  handleCloseUpdateDialog = () => {
    this.setState({
      showUpdateDialog: false,
      updateAHJ: {
        cities: [],
        cityIds: [],
        counties: [],
        countyIds: [],
        state: '',
        field: '',
        fieldId: '',
        update_to: [],
        fieldValue: [],
      },
    });
  };

  handleDialogClose = () => {
    this.setState({ showUpdateDialog: false });
  };

  handleConfirmUpdate = () => {
    const payload = this.getPayload(this.event);
    payload.successCB = () => {
      this.setState({
        updateAHJ: {
          cities: [],
          cityIds: [],
          counties: [],
          countyIds: [],
          state: '',
          field: '',
          fieldId: '',
          update_to: [],
          fieldValue: [],
        },
      });
      this.handleCloseUpdateDialog();
      this.handleFilter();
    };
    this.props.updateAHJRecords(payload);
  };

  handleCreateSuccessCallback = (newUpdateAHJRecord) => {
    this.handleGetSuccessCallback(newUpdateAHJRecord, () => { });
  };

  handleGetSuccessCallback = (updateAHJRecord, callback = () => { }) => {
    const {
      state = '',
      countyIds = [],
      cityIds = [],
      fieldId = '',
      fieldValue = [],
    } = updateAHJRecord;

    this.setState(
      {
        updateAHJ: {
          state,
          countyIds,
          cityIds,
          fieldId,
          fieldValue,
        },
      },
      callback
    );
  };

  getPayload = () => {
    const { updateAHJ } = this.state;

    return {
      requestBody: {
        cityIds: updateAHJ.cityIds,
        countyIds: updateAHJ.countyIds,
        state: updateAHJ.state,
        fieldId: updateAHJ.fieldId,
        fieldValue: updateAHJ.fieldValue,
      },
      successCB: (updateAHJRecord) => this.handleCreateSuccessCallback(updateAHJRecord),
    };
  };

  handleUpdateAHJ = async (e, key, value) => {
    const updateAHJ = this.state.updateAHJ;
    if (isEqual(key, 'state')) {
      updateAHJ[key] = value;
      this.setState({ ...this.state, updateAHJ });
      this.props.getAllApprovedAHJCountiesByState({
        stateAbbr: statesAbbr[value],
        successCb: () => { }
      });
      updateAHJ.counties = [];
      updateAHJ.countyIds = [];
      updateAHJ.cities = [];
      updateAHJ.cityIds = [];
      updateAHJ.field = '';
      updateAHJ.fieldId = '';
      updateAHJ.update_to = [];
      updateAHJ.fieldValue = [];
      this.setState({ updateAHJ });
    }
    if (isEqual(key, 'counties')) {
      updateAHJ[key] = value;
      updateAHJ['countyIds'] = value.map(county => String(county["id"]));
      this.setState({ ...this.state, updateAHJ });
      if (updateAHJ['countyIds'].length === 1) {
        this.props.getAllApprovedAHJCitiesByCountiesAndState({
          stateAbbr: statesAbbr[this.state.updateAHJ.state],
          countyId: updateAHJ['countyIds'].map(id => `${id}`)[0],
          successCb: () => { },
        });
      }
      updateAHJ.cities = [];
      updateAHJ.cityIds = [];
      updateAHJ.field = '';
      updateAHJ.fieldId = '';
      updateAHJ.update_to = [];
      updateAHJ.fieldValue = [];
      this.setState({ updateAHJ });
    }
    if (isEqual(key, 'cities')) {
      updateAHJ[key] = value;
      updateAHJ['cityIds'] = value.map(city => String(city["id"]));
      this.setState({ ...this.state, updateAHJ });
      updateAHJ.field = '';
      updateAHJ.fieldId = '';
      updateAHJ.update_to = [];
      updateAHJ.fieldValue = [];
      this.setState({ updateAHJ });
    }
    if (isEqual(key, 'field')) {
      updateAHJ[key] = value;
      updateAHJ['fieldId'] = value['id'];
      this.setState({ ...this.state, updateAHJ });
      if (value['id'] !== 'display_other_codes_checked' && value['id'] !== 'display_national_electrical_code_checked') {
        this.props.getAllAHJCodesByField({
          fieldId: value['id'],
          successCb: () => { },
        });
      }
      updateAHJ.update_to = [];
      updateAHJ.fieldValue = [];
      this.setState({ updateAHJ });
    }
    if (isEqual(key, 'update_to')) {
      updateAHJ[key] = value;
      if (updateAHJ['fieldId'] === 'other_codes') {
        updateAHJ['fieldValue'] = value.map(code => String(code["long_name"]));
      } else if (updateAHJ['fieldId'] === 'nec' || updateAHJ['fieldId'] === 'ibc' || updateAHJ['fieldId'] === 'ifc' || updateAHJ['fieldId'] === 'irc') {
        updateAHJ['fieldValue'] = [value['long_name']];
      } else {
        updateAHJ['fieldValue'] = [value['id']];
      }
      this.setState({ ...this.state, updateAHJ });
      console.log(updateAHJ);
    }
    this.setState({ updateAHJ: updateAHJ });
    this.setState({ ...this.state, updateAHJ });
  }

  handleFilter = () => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.props.getAllAHJ({
        pageNum: 0,
        recordCount: this.state.rowsPerPage,
        sort_column: this.state.sort_column,
        sort_order: this.state.sort_order,
        ...this.filterParams,
        successCbk: () => {
          this.setState({ isServiceRoleFetched: true });
          this.saveSearchFilters();
        },
      });
    }, 1000);
  };

  getAHJFilterValues() {
    const {
      isRecordsToggleSet: is_records_toggle_set,
      page,
      rowsPerPage: rows_per_page,
      sort_column,
      sort_order,
      modifiedDate: modified_date,
      modifiedDateValue: modified_date_value,
      modifiedDateText: modified_date_text,
      isFromModifiedDate: is_from_modified_date,
      approvedDate: approved_date,
      approvedDateValue: approved_date_value,
      approvedDateText: approved_date_text,
      selectedDate: selected_date,
      isFromApprovedDate: is_from_approved_date,
      dateRange: date_range,
      selectedApprovalStatus: selected_approval_status,
      selectedReferenceStatus: selected_reference_status,
      selectedState: selected_state,
    } = this.state;

    return {
      filter_params: {
        ...this.filterParams,
      },
      other_filters: {
        is_records_toggle_set,
        page,
        rows_per_page,
        sort_column,
        sort_order,
        modified_date,
        modified_date_value,
        modified_date_text,
        is_from_modified_date,
        approved_date,
        approved_date_value,
        approved_date_text,
        selected_date,
        is_from_approved_date,
        date_range,
        selected_approval_status,
        selected_reference_status,
        selected_state,
      },
    };
  }
  toggle = () => this.setState({ isDateRangeOpen: !this.state.isDateRangeOpen });

  handleListFilter = (e, search = {}, value = '') => {
    const searchKey = search.key;
    let selectedValue;
    let inputValue = e.target.value;
    const filterValues = this.state.filterValues;
    filterValues[searchKey] = inputValue;
    this.setState({ filterValues: filterValues });
    if (searchKey === 'current_status') {
      const inputLenth = inputValue.length;
      const indexOfAll = inputValue.indexOf('All');
      if (includes(inputValue, 'All')) {
        selectedValue = indexOfAll === inputLenth - 1 ? ['All'] : inputValue.filter((item) => item !== 'All');
      } else {
        if (inputValue.length === 0) {
          inputValue.unshift('All');
        }
        selectedValue = inputValue;
      }
      this.setState({ selectedApprovalStatus: selectedValue }, () => {
        this.filterParams[searchKey] = this.state.selectedApprovalStatus;
        this.handleFilter();
      });
    } else if (searchKey === 'reference_status') {
      const inputLenth = inputValue.length;
      const indexOfAll = inputValue.indexOf('All');
      if (includes(inputValue, 'All')) {
        selectedValue = indexOfAll === inputLenth - 1 ? ['All'] : inputValue.filter((item) => item !== 'All');
      } else {
        if (inputValue.length === 0) {
          inputValue.unshift('All');
        }
        selectedValue = inputValue;
      }
      this.setState({ selectedReferenceStatus: selectedValue }, () => {
        this.filterParams[searchKey] = this.state.selectedReferenceStatus;
        this.handleFilter();
      });
    } else if (searchKey === 'state') {
      selectedValue = value;
      this.setState({ selectedState: selectedValue }, () => {
        this.filterParams[searchKey] = this.state.selectedState;
        this.handleFilter();
      });
    } else {
      this.filterParams[searchKey] = inputValue;
      this.handleFilter();
    }
  };

  handleCloseSelectedDate = () => {
    this.setState({
      selectSpecificDateOpen: false,
      enableSelectedButton: false,
      isAllDaysBefore: false,
      isAllDaysAfter: false,
      selectedDate: '',
      isFromModifiedDate: false,
      isFromApprovedDate: false,
    });
  };

  handleSaveSelectedDate = () => {
    this.setState({
      selectSpecificDateOpen: false,
      enableSelectedButton: false,
    });
    let filterText = `${moment(this.state.selectedDate).format('M/D/YY')}`;
    const filterDate = new Date(filterText);
    let dateFilterText = filterText;
    let startSearchKey;
    let endSearchKey;
    if (this.state.isFromModifiedDate) {
      startSearchKey = 'from_modified_at';
      endSearchKey = 'to_modified_at';
    }
    if (this.state.isFromApprovedDate) {
      startSearchKey = 'from_verified_at';
      endSearchKey = 'to_verified_at';
    }
    if (this.state.isAllDaysBefore) {
      this.filterParams[startSearchKey] = '';
      this.filterParams[endSearchKey] = filterDate.getTime();
      dateFilterText = ` - ${dateFilterText}`;
    } else if (this.state.isAllDaysAfter) {
      this.filterParams[startSearchKey] = filterDate.getTime();
      this.filterParams[endSearchKey] = '';
      dateFilterText = `${dateFilterText} - `;
    } else {
      this.filterParams[startSearchKey] = filterDate.getTime();
      this.filterParams[endSearchKey] = filterDate.getTime() + 86400000;
    }
    this.handleFilter();
    this.setState({
      isAllDaysBefore: false,
      isAllDaysAfter: false,
    });
    if (this.state.isFromModifiedDate) {
      this.setState({ modifiedDateText: dateFilterText, isFromApprovedDate: false });
    }
    if (this.state.isFromApprovedDate) {
      this.setState({ approvedDateText: dateFilterText, isFromModifiedDate: false });
    }
  };

  getDateValueAndText = (column) => {
    const stateDateValueName = column.key === 'modified_at' ? 'modifiedDateValue' : 'approvedDateValue';
    const stateDateTextName = column.key === 'modified_at' ? 'modifiedDateText' : 'approvedDateText';
    return {
      dateValue: get(this.state, stateDateValueName),
      dateText: get(this.state, stateDateTextName),
    };
  };

  handleUserTypeChange = (e) => {
    const value = e.target.checked === true ? 'personal' : 'All';
    this.setState({ isRecordsToggleSet: e.target.checked });
    this.setState(
      { filterRecord: String(value) },
      () => (this.filterParams['filter_record'] = value === 'All' ? '' : this.state.filterRecord)
    );
    this.handleFilter();
  };

  handleSetRecordsToggle() {
    this.setState({ isRecordsToggleSet: this.props.permitServiceRole === 'db_user' ? true : false }, () => {
      this.filterParams['filter_record'] = this.state.isRecordsToggleSet === true ? 'personal' : '';
      this.handleFilter();
    });
  }

  setInitialFilters(initialAHJFilters) {
    const searchFilters = !isEmpty(localStorage.getItem('ahjFilters'))
      ? JSON.parse(localStorage.getItem('ahjFilters'))
      : initialAHJFilters;

    if (!isEmpty(searchFilters)) {
      this.filterParams = searchFilters.filterParams || searchFilters.filter_params;
      this.rowsPerPage = searchFilters.rowsPerPage;
      this.pageNum = searchFilters.page;
      this.setState(searchFilters, () => {
        this.handleFilter();
      });
    }
  }

  componentDidMount() {
    if (!isEmpty(this.props.permitServiceRole)) {
      if (!isEmpty(localStorage.getItem('ahjFilters'))) {
        this.filterParams = JSON.parse(localStorage.getItem('ahjFilters')).filterParams;
      } else if (!isEmpty(this.props.ahjFilters.filter_params)) {
        this.filterParams = this.props.ahjFilters.filter_params;
      }
      let initialAHJFilters = {};
      if (!isEmpty(localStorage.getItem('ahjFilters'))) {
        initialAHJFilters = JSON.parse(localStorage.getItem('ahjFilters'));
      } else {
        initialAHJFilters = isEmpty(this.props.ahjFilters) ? this.getAHJFilterValues() : this.props.ahjFilters;
      }
      this.setInitialFilters(initialAHJFilters);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.permitServiceRole !== this.props.permitServiceRole) {
      this.handleSetRecordsToggle();
    }
  }

  saveSearchFilters = () => {
    const state = this.state;
    const filterParams = this.filterParams;
    const searchFilters = {
      filterParams: filterParams,
      selectedApprovalStatus: state.selectedApprovalStatus,
      selectedReferenceStatus: state.selectedReferenceStatus,
      page: state.page,
      rowsPerPage: state.rowsPerPage,
      sort_column: state.sort_column,
      sort_order: state.sort_order,
      modifiedDate: state.modifiedDate,
      modifiedDateValue: state.modifiedDateValue,
      modifiedDateText: state.modifiedDateText,
      isFromModifiedDate: state.isFromModifiedDate,
      approvedDate: state.approvedDate,
      approvedDateValue: state.approvedDateValue,
      approvedDateText: state.approvedDateText,
      selectedDate: state.selectedDate,
      selectedState: state.selectedState,
      isFromApprovedDate: state.isFromApprovedDate,
      dateRange: state.dateRange,
      isRecordsToggleSet: state.isRecordsToggleSet,
      filterValues: state.filterValues,
    };
    localStorage.setItem('ahjFilters', JSON.stringify(searchFilters));
    this.props.setAHJFilters(searchFilters);
  };

  render() {
    const {
      classes,
      currentlySending,
      message,
      messageType,
      getAllAhjInProgress,
      ahjList,
      ahjTotalElements,
      permitServiceRole,
      approvedAHJStatesList,
      approvedAHJCountiesByStateList,
      approvedAHJCitiesByCountiesAndStateList,
      ahjCodesList,
      updateAHJRecord,
      countyDataForUpdateAHJRecordsLoading,
      cityDataForUpdateAHJRecordsLoading,
      ahjDataForUpdateAHJRecordsLoading,
    } = this.props;
    const { page, rowsPerPage, sort_column, sort_order, isRecordsToggleSet, updateAHJ } = this.state;
    return (
      <div className={classes.root}>
        <Box className={classes.headerWrapper}>
          <Typography variant="h5" component="h5" className={classes.header}></Typography>
          <Box className={classes.headerSideElements}>
            {isEqual(PERMIT_SERVICE_ROLES.SERVICE_ADMIN, permitServiceRole) && (
              <OutlinedButton
                text={'Update Records'}
                handleClick={this.handleUpdateRecords}
                style={classes.updateRecordsButton}
                statusDashboardBtnStyle={classes.updateRecordsButton}
              />
            )}
            <OutlinedButton
              text={'Clear Filter'}
              handleClick={() => {
                localStorage.removeItem('ahjFilters');
                location.reload();
              }}
              style={classes.clearFilterButton}
              statusDashboardBtnStyle={classes.clearFilterButton}
            />
            <Typography className={classes.selectText}>All Records</Typography>
            <Switch
              checked={isRecordsToggleSet}
              color="primary"
              onChange={(e) => this.handleUserTypeChange(e)}
              disabled={includes(VIEW_ONLY_ROLES, permitServiceRole)}
            />
            <Typography className={classes.selectText}>My Records</Typography>
            <Box className={classes.selectContainer} />
            {!includes(VIEW_ONLY_ROLES, permitServiceRole) && (
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => this.props.history.push('/ahj/new')}
              >
                Create a New Record
              </Button>
            )}
          </Box>
        </Box>
        {currentlySending === true ? (
          <Loader loading={currentlySending} />
        ) : (
          <Fragment>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                <Paper>
                  <TableContainer className={clsx(rowsPerPage === 10 ? classes.container : classes.longContainer)}>
                    <Table stickyHeader>
                      <TableHead className={classes.tableHeader}>
                        <TableRow className={classes.tableRow}>
                          {AHJ_LISTING_COLUMNS.map((column, index) => {
                            return (
                              <TableCell className={classes.headerContainer} key={`ahj_columns_${index}`}>
                                <TableCell className={classes.headerText} key={index}>
                                  {column.sortable === true ? (
                                    <IconButton
                                      size="small"
                                      className={classes.headerButtonText}
                                      disableRipple={true}
                                      onClick={() => this.sortData(column.id)}
                                    >
                                      {column.label}
                                      {sort_column === column.id &&
                                        (sort_order === 'asc' ? <KeyboardArrowUp /> : <KeyboardArrowDown />)}
                                    </IconButton>
                                  ) : (
                                    <IconButton
                                      size="small"
                                      className={classes.headerButton}
                                      disabled={true}
                                      style={{ color: '#FFE785' }}
                                      disableRipple={true}
                                    >
                                      {column.label}
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell className={classes.searchTableCell} colSpan={AHJ_LISTING_COLUMNS.length}>
                                  {column.hasSearch &&
                                    column.key !== 'state' &&
                                    column.key !== 'current_status' &&
                                    column.key !== 'reference_status' &&
                                    column.key != 'modified_at' &&
                                    column.key != 'verified_at' && (
                                      <TextField
                                        value={this.state.filterValues[column.key]}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ classes: { input: classes.inputField } }}
                                        onChange={(e) => this.handleListFilter(e, column)}
                                        variant="outlined"
                                        size="small"
                                      />
                                    )}
                                  {column.hasSearch && column.key === 'state' && (
                                    <MultipleSelectAutoComplete
                                      options={statesList}
                                      selectedValue={this.state.selectedState}
                                      onChangeFunction={(e, value) => this.handleListFilter(e, column, value)}
                                      displayOptionBox={classes.displayOptionBox}
                                      displayOptionText={classes.displayOptionText}
                                      column={column}
                                    />
                                  )}
                                  {(column.key === 'modified_at' || column.key === 'verified_at') && (
                                    <DateFilter
                                      dateValue={this.getDateValueAndText(column).dateValue}
                                      dateText={this.getDateValueAndText(column).dateText}
                                      dateRange={this.state.dateRange}
                                      enableButton={this.state.enableButton}
                                      enableSelectedButton={this.state.enableSelectedButton}
                                      selectedDate={this.state.selectedDate}
                                      selectSpecificDateOpen={this.state.selectSpecificDateOpen}
                                      isDateRangeOpen={this.state.isDateRangeOpen}
                                      handleSaveDateRange={() => this.handleSaveDateRange()}
                                      handleFilterDateChange={(e) => this.handleFilterDateChange(e, column)}
                                      handleCloseDateRange={() => this.handleCloseDateRange()}
                                      handleDateRangeChange={(range) => this.handleDateRangeChange(range)}
                                      handleCloseSelectedDate={() => this.handleCloseSelectedDate()}
                                      handleSaveSelectedDate={() => this.handleSaveSelectedDate()}
                                      handleDateChange={(date) => this.handleDateChange(date)}
                                      toggle={() => this.toggle()}
                                    />
                                  )}
                                  {column.hasSearch && column.key === 'current_status' && (
                                    <FormControl className={classes.inputCheckboxForm}>
                                      <Select
                                        variant="outlined"
                                        MenuProps={MenuProps}
                                        onChange={(e) => this.handleListFilter(e, column)}
                                        value={this.state.selectedApprovalStatus}
                                        className={classes.styleSelect}
                                        renderValue={(selected) => selectMultipleRender(selected, APPROVAL_STATUS_LIST)}
                                        multiple
                                      >
                                        {APPROVAL_STATUS_LIST.map((data, index) => {
                                          return (
                                            <MenuItem key={index} value={data.value}>
                                              <Checkbox
                                                className={classes.inputCheckbox}
                                                checked={this.state.selectedApprovalStatus.indexOf(data.value) > -1}
                                              />
                                              <ListItemText primary={data.title} />
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </FormControl>
                                  )}
                                  {column.hasSearch && column.key === 'reference_status' && (
                                    <FormControl className={classes.inputCheckboxForm}>
                                      <Select
                                        variant="outlined"
                                        MenuProps={RefStatusMenuProps}
                                        onChange={(e) => this.handleListFilter(e, column)}
                                        value={this.state.selectedReferenceStatus}
                                        className={classes.styleSelect}
                                        renderValue={(selected) =>
                                          selectMultipleRender(selected, AHJ_REFERENCE_STATUS_LIST)
                                        }
                                        multiple
                                      >
                                        {AHJ_REFERENCE_STATUS_LIST.map((data, index) => {
                                          return (
                                            <MenuItem key={index} value={data.value}>
                                              <Checkbox
                                                className={classes.inputCheckbox}
                                                checked={this.state.selectedReferenceStatus.indexOf(data.value) > -1}
                                              />
                                              <ListItemText primary={data.title} />
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </FormControl>
                                  )}
                                </TableCell>
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      {getAllAhjInProgress === true || !this.state.isServiceRoleFetched ? (
                        <TableBody>
                          <TableRow>
                            <TableCell
                              colSpan={AHJ_LISTING_COLUMNS.length}
                              style={{ textAlign: 'center', border: 'none' }}
                            >
                              <br />
                              <br />
                              <br />
                              <CircularProgress size={15} />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : isEqual(ahjList, []) === true ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={AHJ_LISTING_COLUMNS.length} style={{ textAlign: 'center' }}>
                              <Typography variant="caption">** No Applications Available **</Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody>
                          {ahjList.map((row, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell>
                                  {get(row, 'name') && (
                                    <Link href={`/ahj/${get(row, 'id')}`} variant="body2">
                                      {row.name}
                                    </Link>
                                  )}
                                </TableCell>
                                <TableCell>{get(row.city, 'city_name') || 'NA'}</TableCell>
                                <TableCell>{get(row.counties?.county, 'county_name') || 'NA'}</TableCell>
                                <TableCell>{get(row, 'state') || 'NA'}</TableCell>
                                <TableCell>{get(row, 'modified_by') || 'NA'}</TableCell>
                                <TableCell>
                                  {get(row, 'modified_at') !== null
                                    ? moment(get(row, 'modified_at')).format('DD MMM YYYY hh:mm A')
                                    : 'NA'}
                                </TableCell>
                                <TableCell className={classes.approvalStatus}>
                                  <ApprovalStatusColumn
                                    unreadComments={row.unread_comments_count}
                                    rowStatus={getStatus(row, 'current_status')}
                                  />
                                </TableCell>
                                <TableCell>{getReferenceStatus(get(row, 'reference_information'))}</TableCell>
                                <TableCell>{get(row, 'verified_by') || 'NA'}</TableCell>
                                <TableCell>
                                  {get(row, 'verified_at') !== null
                                    ? moment(get(row, 'verified_at')).format('DD MMM YYYY hh:mm A')
                                    : 'NA'}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={ahjTotalElements}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(e, newPage) => this.handleChangePage(e, newPage)}
                    onRowsPerPageChange={(e) => this.handleChangeRowsPerPage(e)}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Fragment>
        )}
        {message && messageType && <Snackbar severity={messageType} message={message} />}
        {this.state.showUpdateDialog && (
          <UpdateAHJRecords
            showUpdateDialog={this.state.showUpdateDialog}
            open={this.state.showUpdateDialog}
            handleShowUpdateDialog={() => this.setState({
              showUpdateDialog: !this.state.showUpdateDialog,
              updateAHJ: {
                cities: [],
                cityIds: [],
                counties: [],
                countyIds: [],
                state: '',
                field: '',
                fieldId: '',
                update_to: [],
                fieldValue: [],
              },
            })
            }
            onClose={this.handleCloseUpdateDialog}
            onUpdate={this.handleConfirmUpdate}
            statesList={approvedAHJStatesList}
            countiesList={approvedAHJCountiesByStateList}
            citiesList={(updateAHJ['countyIds'].length > 1) ? MULTIPLE_CITITES_COUNTIES_OPTIONS : approvedAHJCitiesByCountiesAndStateList}
            updateToList={(updateAHJ['fieldId'] === 'display_other_codes_checked' || updateAHJ['fieldId'] === 'display_national_electrical_code_checked') ? YES_NO_OPTIONS : ahjCodesList}
            handleUpdateAHJ={this.handleUpdateAHJ}
            updateAHJ={updateAHJ}
            updateAHJRecord={updateAHJRecord}
            fieldsList={AHJ_FIELDS}
            disableCounty={countyDataForUpdateAHJRecordsLoading}
            disableCity={cityDataForUpdateAHJRecordsLoading}
            disableCode={ahjDataForUpdateAHJRecordsLoading}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getAllAHJ: (payload) => dispatch(getAllAHJ(payload)),
  setAHJFilters: (payload) => dispatch(setAHJFilters(payload)),
  getAllApprovedAHJStates: (payload) => dispatch(getAllApprovedAHJStates(payload)),
  getAllApprovedAHJCountiesByState: (payload) => dispatch(getAllApprovedAHJCountiesByState(payload)),
  getAllApprovedAHJCitiesByCountiesAndState: (payload) => dispatch(getAllApprovedAHJCitiesByCountiesAndState(payload)),
  getAllAHJCodesByField: (payload) => dispatch(getAllAHJCodesByField(payload)),
  updateAHJRecords: (payload) => dispatch(updateAHJRecords(payload)),
});

const mapStateToProps = (state) => ({
  currentlySending: state.adminReducer.currentlySending,
  getAllAhjInProgress: state.adminReducer.getAllAhjInProgress,
  message: state.adminReducer.message,
  messageType: state.adminReducer.messageType,
  ahjList: state.adminReducer.ahjList,
  ahjTotalElements: state.adminReducer.ahjTotalElements,
  permitServiceRole: state.appReducer.permitServiceRole,
  ahjFilters: state.adminReducer.ahjFilters,
  approvedAHJStatesList: state.adminReducer.approvedAHJStatesList,
  approvedAHJCountiesByStateList: state.adminReducer.approvedAHJCountiesByStateList,
  approvedAHJCitiesByCountiesAndStateList: state.adminReducer.approvedAHJCitiesByCountiesAndStateList,
  ahjCodesList: state.adminReducer.ahjCodesList,
  updateAHJRecord: state.adminReducer.updateAHJRecord,
  countyDataForUpdateAHJRecordsLoading: state.adminReducer.countyDataForUpdateAHJRecordsLoading,
  cityDataForUpdateAHJRecordsLoading: state.adminReducer.cityDataForUpdateAHJRecordsLoading,
  ahjDataForUpdateAHJRecordsLoading: state.adminReducer.ahjDataForUpdateAHJRecordsLoading,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StatusDashboard));
